export default "__VITE_PUBLIC_ASSET__4db8b0ab__"